import { HTTPInstance } from "@http/http-instance";
import { Topping } from "./ToppingsAPI.model";

export const getToppings = async (
  restaurantId: string,
): Promise<Topping[]> => {
  const { data } = await HTTPInstance.get<Topping[]>(
    `/public/restaurants/${restaurantId}/toppings`,
  );
  return data;
};
